import CategoriesModel from '../Apis/Categories'
import Controller from './Controller'

export default class CategoriesController extends Controller {
  constructor() {
    super(new CategoriesModel())
  }
  async GetAllTree(params) {
    const response = await this.model.GetAllTree(params)
    return  response
  }
}
